export default {
  badge: 'Käyttöönotto käynnissä',
  title: 'Viimeistele ravintolasi käyttöönotto',
  description: 'Muutama vaihe on vielä jäljellä, ennen kuin ravintolasi voi julkaista.',
  count: '{{done}}/{{total}} vaihetta tehty',
  cta: 'Jatka käyttöönottoa',
  done: {
    badge: 'Kaikki valmista',
    title: 'Kaikki on valmista',
    description: '{{partner}} julkaisee ravintolasi.',
    fallback_partner: 'Palveluntarjoajasi',
  },
};
